import { Heading, Loading, Text } from '@ankor-io/ui-components'

import { buildFunnelStages } from '@/components/dashboard/funnel-stages'
import { useVesselMetricsQuery } from '@/queries'

export const FunnelOverview = () => {
  const { data, isPending, isError, error } = useVesselMetricsQuery()

  if (isPending) {
    return (
      <div data-testid="funnel-overview-loading">
        <Loading variant="spinner" />
      </div>
    )
  }

  if (isError) {
    return (
      <Text
        className="text-red-600 dark:text-red-400"
        data-testid="funnel-overview-error"
      >
        Unable to load funnel metrics: {error.message}
      </Text>
    )
  }

  const stages = buildFunnelStages(data)
  return (
    <section
      aria-labelledby="funnel-heading"
      className="space-y-3"
    >
      <Heading level={2}>Funnel overview totals (# of vessels)</Heading>

      <div
        className="flex w-full flex-col sm:flex-row gap-2 sm:gap-0"
        data-testid="funnel-overview"
      >
        {stages.map((stage, index) => {
          const isLast = index === stages.length - 1

          return (
            <div
              key={stage.id}
              className="relative min-h-24 sm:min-h-28 flex-1 text-white"
              style={{
                background: `linear-gradient(135deg, ${stage.gradientFrom} 0%, ${stage.gradientTo} 100%)`,
                clipPath: isLast
                  ? 'polygon(0 0, 100% 0, 100% 100%, 0 100%, 1.25rem 50%)'
                  : 'polygon(0 0, calc(100% - 1.25rem) 0, 100% 50%, calc(100% - 1.25rem) 100%, 0 100%, 1.25rem 50%)',
                marginLeft: index > 0 ? '-1rem' : undefined,
                zIndex: stages.length - index,
              }}
            >
              <div className="flex h-full flex-col justify-center pl-8 pr-4 py-2">
                <p className="text-[0.625rem] sm:text-xs font-semibold uppercase tracking-widest opacity-90">
                  {stage.label}
                </p>
                <p className="mt-0.5 text-2xl sm:text-3xl font-bold tabular-nums">{stage.value}</p>
                <p className="mt-1 text-[0.625rem] sm:text-xs opacity-90">{stage.conversionLabel}</p>
              </div>
            </div>
          )
        })}
      </div>
    </section>
  )
}
